import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export default function AuthShell({ title, subtitle, children, footer }: Props) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(160deg, #e0e9f3 0%, #f5f7fa 60%)',
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Stack alignItems="center" spacing={2.5}>
          <Stack direction="row" spacing={1.25} alignItems="center" component={RouterLink} to="/" sx={{ textDecoration: 'none' }}>
            <Box
              sx={{
                position: 'relative',
                width: 44,
                height: 44,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #0b5394 0%, #1e88e5 100%)',
                color: '#fff',
                display: 'grid',
                placeItems: 'center',
                fontWeight: 800,
                fontSize: 22,
                letterSpacing: '-1px',
              }}
              aria-hidden
            >
              B
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 5,
                  right: 4,
                  width: 9,
                  height: 9,
                  borderRadius: '50%',
                  bgcolor: 'secondary.main',
                }}
              />
            </Box>
            <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 700 }}>
              Baton
            </Typography>
          </Stack>
          <Card sx={{ width: '100%', mt: 2 }}>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Typography variant="h4" component="h1" sx={{ mb: 0.5 }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  {subtitle}
                </Typography>
              )}
              {children}
            </CardContent>
          </Card>
          {footer && (
            <Typography variant="body2" color="text.secondary">
              {footer}
            </Typography>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
